'use client';


import { loadSounds, playSfx, wireUnlock } from './audioEngine';

const UI_SFX = ['click', 'buttonclickrelease', 'menu_select', 'click_wheel'] as const;
let wired = false;

export function preloadUiSounds(): void {
  void loadSounds(UI_SFX).catch(() => undefined);
}

export function playEarnings(volume = 0.6): void {
  void loadSounds(['earnings']).then(() => playSfx('earnings', volume)).catch(() => undefined);
}

const isInteractive = (el: Element): boolean => {
  const tag = el.tagName;
  if (tag === 'BUTTON' || tag === 'A' || tag === 'SUMMARY' || tag === 'INPUT' || tag === 'LABEL') return true;
  const role = el.getAttribute('role');
  if (role === 'button' || role === 'link' || role === 'tab' || role === 'menuitem' || role === 'switch') return true;
  try { if (window.getComputedStyle(el).cursor === 'pointer') return true; } catch { }
  return false;
};

const isDisabled = (el: Element): boolean =>
  ('disabled' in el && el.disabled === true) || el.getAttribute('aria-disabled') === 'true';

// WHY: `click`, NOT pointerdown: the browser suppresses click on a press that turns into a scroll/swipe, so scrolling
// stays silent
export function initClickSound(): void {
  if (wired || typeof document === 'undefined') return;
  wired = true;
  wireUnlock();
  document.addEventListener('click', (e) => {
    const target = e.target instanceof Element ? e.target : null;
    if (!target) return;

    const marker = target.closest('[data-sound]');
    const ds = marker?.getAttribute('data-sound');
    if (ds === 'none') return;
    const cta = ds === 'cta';
    const ring = ds === 'ring';

    let interactiveEl: Element | null = null;
    for (let el: Element | null = target, i = 0; el && i < 8; i++, el = el.parentElement) {
      if (isInteractive(el)) { interactiveEl = el; break; }
    }
    if (!interactiveEl && cta && marker) interactiveEl = marker;
    if (!interactiveEl || isDisabled(interactiveEl)) return;

    const sound = cta ? 'buttonclickrelease' : ring ? 'click' : 'menu_select';
    playSfx(sound, cta ? 1 : 0.5);
  }, true);
}
